import getAtPath from 'lodash/get';

export default (permissions, path) => getAtPath(permissions, path, { view: false, modify: false });
